import { BTButtonDeprecated } from "commonComponents/btWrappers/BTButtonDeprecated/BTButtonDeprecated";
import {
    GridViewColumn,
    type GridViewItem,
    type IGridSettingsFormValues,
} from "commonComponents/utilities/Grid/common/GridSettings/GridSettings.api.types";
import { type GridColumn } from "commonComponents/utilities/Grid/GridContainer.types";

import "./UnsavedViewChangesHeader.less";

interface IUnsavedViewChangesHeaderProps {
    onSaveView: (
        values: IGridSettingsFormValues,
        columns: GridViewColumn[],
        saveAsNew: boolean,
    ) => Promise<void>;
    onAddNewSavedView: () => void;
    onResetView: () => void;
    columnsList?: GridColumn<unknown>[];
    selectedGridView: GridViewItem;
}

export const UnsavedViewChangesHeader: React.FunctionComponent<IUnsavedViewChangesHeaderProps> = (
    props,
) => {
    const { onSaveView, onAddNewSavedView, onResetView, columnsList, selectedGridView } = props;

    const handleSaveSettings = async () => {
        const formValues: IGridSettingsFormValues = {
            viewName: selectedGridView.viewName,
            isDefault: selectedGridView.isDefault,
            isPrivate: selectedGridView.isPrivate,
            savedView: selectedGridView.viewId,
            columns: columnsList!.map((col) => col.id),
        };
        await onSaveView(
            formValues,
            columnsList!.filter((c) => c.enabled).map((col) => new GridViewColumn(col)),
            false,
        );
    };

    return (
        <div className="UnsavedViewsChangesHeader">
            <div className="UnsavedChanges">Your view has unsaved changes.</div>
            {selectedGridView?.canEdit && (
                <span className="padding-left-sm">
                    <BTButtonDeprecated
                        type="primary"
                        data-testid="saveView"
                        onClick={handleSaveSettings}
                    >
                        Save
                    </BTButtonDeprecated>
                </span>
            )}
            <span className="padding-left-sm">
                <BTButtonDeprecated type="secondary" data-testid="resetView" onClick={onResetView}>
                    Reset
                </BTButtonDeprecated>
            </span>
            <span className="padding-left-sm">
                <BTButtonDeprecated
                    type="secondary"
                    data-testid="newSavedView"
                    onClick={onAddNewSavedView}
                >
                    Save As
                </BTButtonDeprecated>
            </span>
        </div>
    );
};
